let validate = binding => {
  if (typeof binding.value !== 'function') {
    console.warn('[click-outside] provided expression', binding.expression, 'is not a function.')
    return false
  }

  return true
}

let isPopup = (item, elements) => {
  if (!item || !elements) return false

  for (element in elements) {
    try {
      if (item.contains(element)) return true
      if (element.contains(item)) return false
    } catch (error) {
      return false
    }
  }

  return false
}

let isServer = node => {
  return typeof node.componentInstance !== 'undefined' && node.componentInstance.$isServer
}

export default {
  bind: function (element, binding, node) {
    if (!validate(binding)) return

    let handler = event => {
      if (!node.context) return
      let elements = event.path || (event.composedPath && event.composedPath())
      elements && elements.length > 0 && elements.unshift(event.target)
      if (element.contains(event.target) || isPopup(node.context.item, elements)) return
      element._clickOutside.callback(event)
    }

    element._clickOutside = {
      handler: handler,
      callback: binding.value
    }

    !isServer(node) && document.addEventListener('click', handler)
  },

  update: function (element, binding) {
    if (validate(binding)) element._clickOutside.callback = binding.value
  },

  unbind: function (element, binding, node) {
    !isServer(node) && document.removeEventListener('click', element._clickOutside.handler)
    delete element._clickOutside
  }
}
